import {
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  IconButton,
  styled,
  Button,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import TCForm_X from "../../templates/tcForm_X";
import moment from "moment";
import {
  BulkUpdateStudent,
  UpdateStudentv2,
} from "../../api/Students-Management/bulk-update";
import ToastSnackbar, { SnackbarHandle } from "../../common/ToastNotification";
import Character_certificate from "../../templates/character_certificate";

const MyCustomButton = styled(Button)(({ theme }) => ({
  fontFamily: "Motiva Sans Bold",
  fontSize: "0.80rem",
  fontWeight: "700",
  border: "1px solid #edf3f5",
  borderRadius: "4px",
  background: "#2e186a",
  boxShadow: "0 16px 30px rgb(23 31 114 / 20%)",
  marginTop: "0rem",
  "&:hover": {
    color: "#fff",
    border: "1px solid rgb(255, 130, 92)",
    backgroundColor: "rgb(255, 130, 92)",
  },
}));

interface ProfileDialogProps {
  isOpen: boolean;
  onClose: () => void;
  tcdata: any;
  onSuccess: (data: any) => void;
  certType: string;
}

const PrintTCDialogBox: React.FC<ProfileDialogProps> = ({
  isOpen,
  onClose,
  tcdata,
  onSuccess,
  certType,
}) => {
  const tableRefs = useRef([]);

  console.log(tcdata);

  let printRef = useRef();
  const snackbarRef = useRef<SnackbarHandle>(null);

  const [certNo, setCertNo] = useState<string | undefined>(undefined);
  const [updating, setUpdating] = useState(false);

  const handlePrint = useReactToPrint({ documentTitle: "Payment Receipt" }) as (
    content: () => HTMLElement | null
  ) => () => void;

  // const handleChange = (event: any) => {
  //   const value = event.target.value;
  //   setShowPdf(false);
  //   setSelectedFeeMonth(value);
  // };

  const handlePrintTC = async () => {
    try {
      // if (!tcdata?.certNo) {
      //   snackbarRef.current?.showSnackbar(`TC No Is Empty`, "warning");
      //   return;
      // }
      // if (!tcdata?.applicationDate) {
      //   snackbarRef.current?.showSnackbar(
      //     `TC Application Date Is Empty`,
      //     "warning"
      //   );
      //   return;
      // }
      // if (!tcdata?.issueDate) {
      //   snackbarRef.current?.showSnackbar(`Issue Date Is Empty`, "warning");
      //   return;
      // }

      setUpdating(true);
      console.log(tcdata?.issueDate);
      const payload = {
        user: tcdata?.loggedInUser || "testuser",
        arrayOfItems: [
          {
            id: tcdata.id,
            tc_number: certNo || tcdata?.certNo,
            tc_issue_date: tcdata?.issueDate,
            applicationDate: tcdata?.applicationDate || "",
          },
        ],
      };
      console.log(payload);
      const response = await UpdateStudentv2(payload);
      if (response) {
        if (response.status === "SUCCESS")
          snackbarRef.current?.showSnackbar(`${response.message}`, "success");
        onSuccess({
          id: tcdata.id,
          tc_number: certNo || tcdata?.certNo,
          tc_issue_date: tcdata?.issueDate,
          applicationDate: tcdata?.applicationDate,
        });
        setTimeout(() => {
          try {
            handlePrint(() => printRef.current!)();
          } catch (error) {
            console.log("Handling print function call error.");
            console.log(error);
          } finally {
            setUpdating(false);
          }
        }, 400);

        if (response.status === "FAIL")
          snackbarRef.current?.showSnackbar(`${response.message}`, "warning");
      } else {
        snackbarRef.current?.showSnackbar(`Some Error. Not Updated`, "warning");
      }
    } catch (error) {
      console.log(error);
      snackbarRef.current?.showSnackbar(
        `Some Exception Occured. Not Updated`,
        "warning"
      );
    }
  };

  const handlePrintCert = async () => {
    try {
      setTimeout(() => {
        try {
          handlePrint(() => printRef.current!)();
        } catch (error) {
          console.log("Handling print function call error.");
          console.log(error);
        } finally {
        }
      }, 400);
    } catch (error) {
      console.log(error);
      snackbarRef.current?.showSnackbar(`Some Exception Occured.`, "warning");
    }
  };

  const handleDialogClose = (event: object, reason: string) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      // Prevent closing when clicking outside or pressing escape.
      return;
    }
    // Otherwise, call the parent's onClose function.
    onClose();
  };

  const handleCertNoChange = (newCertNo: any) => {
    console.log("********* newCertNo ***************");
    console.log(newCertNo);
    setCertNo(newCertNo);
    // Optionally trigger a save to DB here too
  };

  return (
    <>
      <ToastSnackbar ref={snackbarRef} />
      <Dialog
        open={isOpen}
        onClose={handleDialogClose}
        maxWidth={false}
        sx={{
          display: "flex",
          alignItems: "center", // ✅ Center vertically
          justifyContent: "center", // ✅ Center horizontally
          "& .MuiDialog-paper": {
            width: "56vw", // Set dialog width
            height: "100vh",
            maxWidth: "90vw",
            minHeight: "40vh", // Prevents it from being too short
          },
        }}
      >
        <DialogTitle>
          {/* <Typography variant="h5">
            <strong>Fee Payment History</strong>
          </Typography> */}

          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{
            overflowX: "none",
            overflowY: "auto",
            "&::-webkit-scrollbar": {
              width: "8px", // Width of the scrollbar
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "#f1f1f1", // Background of the scrollbar track
              borderRadius: "10px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#888", // Color of the scroll thumb
              borderRadius: "10px", // Rounded corners
            },
            "&::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "#555", // Darker color on hover for the thumb
            },
          }}
        >
          {/*@ts-ignore */}
          {certType === "TC" && tcdata && (
            <TCForm_X
              //@ts-ignore
              data={tcdata}
              ref={printRef}
              onCertNoChange={handleCertNoChange}
            />
          )}

          {certType === "CHARACTER" && tcdata && (
            <Character_certificate
              //@ts-ignore
              data={tcdata}
              ref={printRef}
            />
          )}
        </DialogContent>

        <DialogActions sx={{ alignItems: "center", justifyContent: "center" }}>
          <MyCustomButton onClick={onClose} variant="contained">
            Close
          </MyCustomButton>

          {certType === "TC" ? (
            tcdata.certIssued ? (
              <MyCustomButton onClick={handlePrintCert} variant="contained">
                Print
              </MyCustomButton>
            ) : (
              <MyCustomButton
                onClick={handlePrintTC}
                variant="contained"
                disabled={updating}
                startIcon={
                  updating ? <CircularProgress size={20} /> : undefined
                }
              >
                {updating ? "...Wait" : "Issue And Print"}
              </MyCustomButton>
            )
          ) : null}

          {certType === "CHARACTER" && (
            <MyCustomButton onClick={handlePrintCert} variant="contained">
              Print
            </MyCustomButton>
          )}
        </DialogActions>
      </Dialog>

      {/* {printData && (
        <div style={{ display: "none" }}>
       
          <FeesReceiptTemplatev2 ref={printRef} feesData={printData} />
        </div>
      )} */}
    </>
  );
};

export default PrintTCDialogBox;
